import { Reducer } from 'redux'

import {
  BuyerContactsAction,
  BuyerContactsActionTypes,
  Contacts,
  initialBuyerContactsState,
} from './types'

export const reducer: Reducer<Contacts, BuyerContactsAction> = (
  state = initialBuyerContactsState,
  action
) => {
  switch (action.type) {
    case BuyerContactsActionTypes.SET_BUYER_CONTACTS: {
      return {
        ...state,
        contacts: action.payload.contacts,
      }
    }
    default:
      return state
  }
}
